import { render, staticRenderFns } from "./sdetail.vue?vue&type=template&id=cb725f9a"
import script from "./sdetail.vue?vue&type=script&lang=js"
export * from "./sdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports